import { ComponentSettingsChartMeasureField, DatasetField, MeasureField } from '@report-content';

export function generateMeasureFieldId(): string {
    return Date.now().toString(36) + Math.random().toString(36);
}

export function getFirstAllowedFieldAsMeasure<T extends MeasureField>(
    datasetFields: Array<DatasetField>,
    measureFields: Array<T>,
    fieldToMeasuredField: (datasetField: DatasetField) => T,
): T | false {
    const allowedField = datasetFields.filter(
        (datasetField) =>
            !measureFields || measureFields.findIndex((f) => f.reference_name == datasetField.reference_name) == -1,
    );

    if (allowedField.length == 0) {
        return false;
    }

    // Try to get first numeric field, if there is no numeric fields, take first
    let field = allowedField.find((f) => f.value_type == 'numeric');
    if (!field) {
        field = allowedField[0];
    }
    return fieldToMeasuredField(field);
}

export function getMeasureFieldOptionForFormUId<T extends ComponentSettingsChartMeasureField>(
    field: T,
    option: string,
) {
    const formFieldPrefix = '__measure_field__name_';
    return `${formFieldPrefix}${field.uId}_${option}`;
}
